import axiosInstance from "../axiosInstance";

export const historicalInventorySnapshotHealthService = {
  fetch: async (signal) => {
    const response = await axiosInstance.get(
      "/historical-inventory-snapshot-health",
      { signal, suppressErrorToast: true },
    );
    return response.data;
  },

  recapture: async (clients) => {
    const response = await axiosInstance.post(
      "/historical-inventory-snapshot-health",
      { clients },
      { suppressErrorToast: true },
    );
    return response.data;
  },

  fetchRun: async (id, signal) => {
    const response = await axiosInstance.get(
      `/historical-inventory-snapshot-health/${id}`,
      { signal, suppressErrorToast: true },
    );
    return response.data;
  },
};
